// eslint-disable-next-line import/no-webpack-loader-syntax
require('expose-loader?RightSidebarApp!../../src/app/layout_apps/right_sidebar');
